import { render, staticRenderFns } from "./TalentCenter.vue?vue&type=template&id=4e2f8c81&scoped=true"
import script from "./TalentCenter.vue?vue&type=script&lang=js"
export * from "./TalentCenter.vue?vue&type=script&lang=js"
import style0 from "./TalentCenter.vue?vue&type=style&index=0&id=4e2f8c81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f8c81",
  null
  
)

export default component.exports